<template>
  <v-app>
    <cabecerados />
    <v-main >

      <v-container  >

        <section v-if="activopr"  >
          <v-row justify="center" align="center">
            <v-col cols="12" lg="8" md="8" sm="12">
              <v-card >
                <v-card-text>
              <v-row align="center" class="text-center">
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-img width="270px" :src="logo270"></v-img>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <h1  class="display-1 font-weight-bold">
                    Hola {{promotor.promotorNombre}}
                  </h1>
                  <p style="font-size: medium; text-align: justify; word-break: normal;">
                    Bienvenidos, elige lo que necesites hacer para ingresar a tus invitados o gestionarlos.
                  </p>
                </v-col>
              </v-row>
              <v-row>
            <v-col cols="12" v-if="promotor.lista" lg="6" md="6" sm="12">
              <v-card elevation="10" class="ma-10">
                <v-card-text >
                  <v-row justify="center" align="center">
                    <v-col cols="12" lg="12" md="12" sm="12">
                      <v-img src="@/assets/icons/listas_icon.png" contain @click="eligelista= true" > </v-img>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12" lg="12" md="12" sm="12">
                      <h1 style="text-align: center;" @click="eligelista= true">Listas</h1>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col v-if="promotor.qrlista"  cols="12" lg="6" md="6" sm="12">

              <v-card elevation="10" class="ma-10">
                <v-card-text >
                  <v-row justify="center" align="center">
                    <v-col cols="12" lg="12" md="12" sm="12">
                      <v-img src="@/assets/icons/listas_qr.png" @click="eligeqr= true" contain > </v-img>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12" lg="12" md="12" sm="12">
                      <h1 style="text-align: center;" @click="eligeqr= true">Genera QR</h1>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
                <v-col v-if="falso"   cols="12" lg="6" md="6" sm="12">

                  <v-card elevation="10" class="ma-10">
                    <v-card-text >
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <v-img src="@/assets/icons/promoter.png" @click="creapromo= true" contain > </v-img>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1 style="text-align: center;" @click="creapromo= true">Crear Promotor</h1>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col   cols="12" lg="6" md="6" sm="12">

                  <v-card elevation="10" class="ma-10">
                    <v-card-text >
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <v-img src="@/assets/icons/lista_invitados.png" @click="eligemilista= true" contain > </v-img>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1 style="text-align: center;" @click="eligemilista= true">Mis Invitados</h1>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col   cols="12" lg="6" md="6" sm="12">

                  <v-card elevation="10" class="ma-10">
                    <v-card-text >
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <v-img src="@/assets/icons/listas_reports.png" @click="eligereportelista= true" contain > </v-img>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <h1 style="text-align: center;" @click="eligereportelista= true">Reporte</h1>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
                </v-card-text></v-card></v-col>
          </v-row>
        </section>
        <section v-else>
          <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1  class="display-1 font-weight-bold">
                Hola {{promotor.promotorNombre}}, fuiste desactivado como promotor.
              </h1>
            </v-col>
          </v-row>
        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
        <qrlista :promotor="promotor" :url="urlqr" :fiestas="fiestas" :tipolistas="tipolistas" :cambia="eligeqr" @cierra="cerrarmodales" />
        <mlista :promotor="promotor" :fiestas="fiestas" :tipolistas="tipolistas" :cambia="eligelista" @cierra="cerrarmodales" />
        <milista :promotor="promotor" :fiestas="fiestas" :cambia="eligemilista"  @cierra="cerrarmodales" />
        <reportelista :promotor="promotor"   :cambia="eligereportelista" @cierra="cerrarmodales" />
        <crearpromo  :cambia="creapromo" @cierra="cerrarmodales" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment";
import Cabecerados from "@/components/general/cabecerados";
import Qrlista from "@/components/modals/promotores/qrlista";
import Mlista from "@/components/modals/promotores/mlista";
import Milista from "@/components/modals/promotores/milista";
import Reportelista from "@/components/modals/promotores/reportelista";
import Crearpromo from "@/components/modals/promotores/crearpromo";
export default {
  name: "lst",
  title: "Tunay - Menu Promotor",
  components: {
    Crearpromo,
    Reportelista,
    Milista,
    Mlista,
    Qrlista,
    Cabecerados

  },

  data () {
    return {
      md5promo: '',
      overlay: false,
      alertnuevo: false,
      logoexist: false,
      logoimg: null,
      creapromo:false,
      urlqr:'',
      botn: false,
        falso:false,
      cantidad: 0,
      cantmax: {
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual: '',
        posibles: ''
      },
      maximo: 0,
      progr:false,
      mostrarlista:true,
      logo270:'',
      nombres:'',
      fiestaId:0,
      tipoListaId:0,
      eligeqr:false,
      eligelista:false,
      eligemilista:false,
      eligelinklista:false,
      eligereportelista:false,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
        { text: 'Fecha', value: 'fechaActo' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      promotor:{},
      fiestas: [],
      dialogdelete: false,
      tipolistas:[],
      alerterror:false,
      texterror:'',
      activopr:true,
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
      meta: [
        {property: "og:image", content: this.logo270, vmid: "og:image"},
        {property: "og:image:width", content: "699", vmid: "og:image:width"},
        {property: "og:image:height", content: "366", vmid: "og:image:height"},
        {
          property: "og:description",
          vmid: "og:description",
          content: "Lista de  "+this.titulonegocio
        },
        {
          property: "og:title",
          vmid: "og:title",
          content: this.titulonegocio
        }
      ]
    }
  },
  mounted (){
    this.md5promo =  this.$route.params.md5promo;
    this.damepromotor();
  }
,

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    cerrarmodales(){
      this.eligeqr = false
      this.eligelista = false
      this.eligemilista = false
      this.eligelinklista = false
      this.eligereportelista = false
      this.creapromo = false
    },
    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
      if (fechamax <= hoy ){
        this.botn = true
      }else{
        this.botn = false
      }
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true

        axios
            .post(urlfiesta,bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            })
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });
      }
    },

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },

    save () {
      this.overlay = true;
      this.vernombres()
      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotor.id);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("nombres",this.nombres);
      axios
          .post('lista/fiesta/nuevo',bodyFormData).then(response => {
        this.listas=response.data
        this.mostrarlista = false
            this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    },
    vernombres(){
      let maximo = this.cantmax.posibles;
      var arraycad = this.nombres.split(/\r?\n/)
      this.nombres = ""
      var nmb = 0;
      if(arraycad.length< maximo){
        nmb = arraycad.length
      }else{
        nmb = maximo
      }

      for(let i=0;i<nmb;i++){
        if(i === nmb-1){
          this.nombres = this.nombres + arraycad[i]
        }else{
          this.nombres = this.nombres + arraycad[i] + "\r\n"

        }
      }
      if(arraycad.length> maximo){
        this.texterror="Su lista sobrepasa la cantidad de nombres permitida, se recorto a lo posible"
        this.alerterror = true
      }
    },
    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    damefiestas(){
      this.progr = true;
      let urlfiesta = 'promotores/fiestas';
      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotor.id);
      axios
          .post(urlfiesta,bodyFormData)
          .then(response => {
            this.fiestas = response.data;
            this.logo270 = this.fiestas[0].temporada.negocio.logo270
            this.progr = false;
            this.dametipolistas()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damepromotor(){
      this.overlay = true;
      axios
          .get('promotores/lista/'+this.md5promo)
          .then(response => {
            this.promotor = response.data;
            this.titulonegocio = this.promotor.promotorNombre
            this.editedItem.listaFiesta.promotor = this.promotor
            this.activopr = this.promotor.activo
            this.overlay = false;
            this.urlqr = 'https://tunay.app/'+this.promotor.negocioTag+'/codigoqr'
            this.damefiestas()
          })
          .catch((error)  => {
            this.overlay = false;
            console.log(error);
          });
    },

    borralo (){
      this.overlay = true
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico)
          .then(response => {
            console.assert(true,response);
            this.dialogdelete = false;
            this.listas=response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
    dametipolistas(){
      this.progr = true;
      axios
          .get('promotortipolistas/promotor/'+this.promotor.id)
          .then(response => {
            this.tipolistas = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>

</style>
